class RevealingTextElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Check if GSAP and SplitText are defined
    if (typeof gsap === 'undefined' || typeof SplitText === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.warn('GSAP or SplitText or ScrollTrigger is not loaded. Skipping revealing text animation.');
      return;
    }
    console.log('GSAP and SplitText are loaded. Initializing revealing text animation.');

    const hoverColor = this.dataset.hoverColor;
    const headingColor = this.dataset.textColor;
    const runMode = this.dataset.run || "multi";

    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // If user prefers reduced motion, just make text visible and skip animation
    if (prefersReducedMotion) {
      gsap.set(this, { visibility: "visible" });
      console.log(`Reduced motion enabled. Element set to visible.`);
      return;
    }

    // Otherwise, run the animation
    const split = SplitText.create(this.children, {
      type: "words, chars",
      wordsClass: "word",
      charsClass: "char",
    });

    console.log(`Element split into ${split.chars.length} characters.`);

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this,
        start: "top 75%",
        end: "bottom 25%",
        toggleActions: runMode === "once"
        ? "play none none none"
        : "play reverse play reverse",
        onEnter: () => console.log(`ScrollTrigger entered for element`),
        onLeaveBack: () => console.log(`ScrollTrigger left back for element`),
      },
    });

    tl.to(split.chars, {
        color: hoverColor,
        duration: 0.5,
        stagger: { amount: 0.8 },
      })
      .to(split.chars, {
        color: headingColor,
        duration: 0.5,
        stagger: { amount: 0.8 },
      }, 0.4);

    gsap.set(this, { visibility: "visible" });
    console.log(`Animation set for element.`);
  }
}

customElements.define('revealing-text-element', RevealingTextElement);
